var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9209 1.50495C17.9206 1.90264 17.7623 2.28392 17.4809 2.56495L9.80895 10.237C9.57673 10.4691 9.39252 10.7447 9.26684 11.0481C9.14117 11.3515 9.07648 11.6766 9.07648 12.005C9.07648 12.3333 9.14117 12.6585 9.26684 12.9618C9.39252 13.2652 9.57673 13.5408 9.80895 13.773L17.4709 21.435C17.7442 21.7179 17.8954 22.0968 17.892 22.4901C17.8885 22.8834 17.7308 23.2596 17.4527 23.5377C17.1746 23.8158 16.7983 23.9735 16.405 23.977C16.0118 23.9804 15.6329 23.8292 15.3499 23.556L7.68795 15.9C6.65771 14.8677 6.0791 13.4689 6.0791 12.0105C6.0791 10.552 6.65771 9.15322 7.68795 8.12095L15.3599 0.443953C15.5697 0.234037 15.8371 0.0910666 16.1281 0.0331324C16.4192 -0.0248017 16.7209 0.00490445 16.9951 0.118492C17.2692 0.232079 17.5036 0.424443 17.6684 0.671242C17.8332 0.918041 17.9211 1.20818 17.9209 1.50495Z",
    fill: "#182444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBack);
export default __webpack_public_path__ + "static/media/go_back.f9200df78832e9c00728787fd0286275.svg";
export { ForwardRef as ReactComponent };